module.exports = __webpack_public_path__ + "assets/launchdarkly.d4f64d43.svg";